$(function() {
    function dispatchLanguageChangeEvent() {
        var event = new CustomEvent('syc.language.changed');
        document.dispatchEvent(event);
    }
    
    $('#change_language_form').on('submit', dispatchLanguageChangeEvent); 
});